export default "__VITE_ASSET__GIDL8X$j__"